import React from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";

import Analyse from "../screens/Analyse";
import { connect } from "react-redux";
import Home from "../screens/Home";
import VideoTab from "../screens/VideoTab";
import MatchUpdate from "../screens/MatchUpdate";
import { ManagementScreen } from "../screens/management";
import LiveTaggingBoard from "../screens/LiveTaggingBoard";
import VideoTabOld from "../screens/VideoTabOld";
import TechQC from "../screens/TechQC";
import TechQCMS from "../screens/TechQCMS";
import ReviewPortal from "../screens/ReviewPortal";

const MainRouter = (props) => {
  let location = useLocation();
  let background = location.state && location.state.background;
  return (
    <Switch location={background || location}>
      <Route exact path="/">
        <Redirect to="/home" />
      </Route>
      <Route path="/home">
        <Home />
      </Route>
      <Route path="/management">
        <ManagementScreen />
      </Route>
      <Route path="/analyse/:matchId">
        <Analyse />
      </Route>
      <Route path="/live-analyse/:matchId">
        <LiveTaggingBoard />
      </Route>
      <Route path="/matchupdate/:matchId">
        <MatchUpdate />
      </Route>
      <Route path="/videoplayer">
        <VideoTab />
      </Route>
      <Route path="/videoplayerold">
        <VideoTabOld />
      </Route>
      <Route path="/techQC/:matchId">
        <TechQC />
      </Route>
      <Route path="/techQCMS/:matchId">
        <TechQCMS />
      </Route>
      <Route path="/review/:matchId">
         <ReviewPortal />
      </Route>
    </Switch>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  };
};

export default connect(mapStateToProps, {})(MainRouter);
